import React from 'react';
import { Descriptions, Spin, Tag, Typography } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import { closingOutcomeLabel, stageCategoryLabel } from '../stageMetadata';
import type { LeadPipelineStageDetail } from '../types';
import AuditProperties from '../../../../components/AuditProperties';

const { Text } = Typography;

export interface LeadPipelineStageViewDrawerProps {
  open: boolean;
  onClose: () => void;
  stage: LeadPipelineStageDetail | null | undefined;
  loading: boolean;
  onEdit: () => void;
}

const LeadPipelineStageViewDrawer: React.FC<LeadPipelineStageViewDrawerProps> = ({
  open,
  onClose,
  stage,
  loading,
  onEdit,
}) => {

  return (
    <Drawer
      title="Pipeline stage details"
      placement="right"
      size="large"
      open={open}
      onClose={onClose}
      extra={
        <Typography.Link onClick={onEdit} style={{ marginRight: 8 }}>
          Edit
        </Typography.Link>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : stage === null || stage === undefined ? (
        <Text type="secondary">Stage not found.</Text>
      ) : (
        <>
          <div className="cp-form-section">
            <Descriptions column={2} size="small" title="Basic information">
              <Descriptions.Item label="Label" span={2}>
                <Text strong>{stage.label}</Text>
                {stage.isSystem && (
                  <Tag color="blue" style={{ marginLeft: 8 }}>
                    System
                  </Tag>
                )}
              </Descriptions.Item>
              <Descriptions.Item label="Code">{stage.code}</Descriptions.Item>
              <Descriptions.Item label="Sort order">{stage.sortOrder}</Descriptions.Item>
              <Descriptions.Item label="Category">
                {stageCategoryLabel(stage.category)}
              </Descriptions.Item>
              <Descriptions.Item label="Outcome">
                {closingOutcomeLabel(stage.closingStatus)}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {stage.isActive ? (
                  <Tag color="green">Active</Tag>
                ) : (
                  <Tag color="default">Inactive</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          </div>

          <AuditProperties
            className="cp-form-section"
            values={{
              createdAtUtc: stage.createdAtUtc,
              createdByDisplayName: stage.createdByDisplayName,
              createdByUserId: stage.createdByUserId,
              lastModifiedAtUtc: stage.lastModifiedAtUtc,
              modifiedByDisplayName: stage.modifiedByDisplayName,
              modifiedByUserId: stage.modifiedByUserId,
            }}
          />
        </>
      )}
    </Drawer>
  );
};

export default LeadPipelineStageViewDrawer;
